<script setup>
import { NFlex } from 'naive-ui';
import { computed } from 'vue'; 

import literacyIcon from '@/assets/images/result/literacy_ic_book.png';
import numeracyIcon from '@/assets/images/result/numeracy_ic_book.png'

const props = defineProps({
  type: { 
    type: String,
    required: true,
    validator: (value) => ['literacy', 'numeracy'].includes(value)
  },
  title: { 
    type: String,
    required: true
  },
  region: { 
    type: String,
    default: ''
  },
  hideTitleBox: {
    type: Boolean,
    default: false 
  }
});

const iconSrc = computed(() => {
  return props.type === 'literacy' ? literacyIcon : numeracyIcon;
});

const description = computed(() => {
  return props.type === 'literacy'
    ? '학습과 삶의 맥락에서 다양한 내용과 형식의 글을 정확하게 이해하고 효과적으로 맥락에 맞게 표현하는 능력'
    : '학습과 일상을 포함한 다양한 상황에서 수학의 내용과 방법을 활용하여 추론, 의사소통, 문제를 해결하는 능력';
});

const displayTitle = computed(() => {  return props.type === 'literacy' ? '문해력' : '수리력'; });
</script>

<template>
  <div class="sub-head" :class="[props.type, props.region, { 'pb-4': !props.hideTitleBox }]">
    <n-flex :wrap="false" :size="10" align="center">
      <img :src="iconSrc" :alt="`${title}-아이콘`" />
      <p class="title-text">{{ displayTitle }}</p>
      <p class="description-text">{{ description }}</p>
    </n-flex>
    <h4 class="title-box" v-if="!props.hideTitleBox">{{ props.title }}</h4> 
  </div>
</template>

<style lang="scss" scoped>
.sub-head {
  text-align: center;

  .n-flex {
    line-height: 1; 
    height: 80px;
    
    .title-text {
      font-size: 24px;
      font-weight: 500;
      line-height: 1;
    }
    .description-text {
      line-height: 1;
    }
  }

  &.literacy {      
    .n-flex {
      img {
        margin-bottom: 3px;
      }
      .title-text {
        color: var(--result-blue);          
      }        
    }
    h4 {
      background-color: var(--result-light-blue);  
      border-bottom: 6px solid var(--result-blue);       
    }
    &.seoul {
      h4 {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          background-image: url("@/assets/images/result/char_01.png");
          width: 144px;
          height: 120px;
          top: 50%;
          right: -30px;
          transform: translateY(-50%);
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
    }
  }

  &.numeracy {  
  .n-flex {
      img {
        margin-bottom: 3px;
      }
      .title-text {
        color: var(--result-red);          
      }        
    }
    h4 {
      background-color: var(--result-light-red);  
      border-bottom: 6px solid var(--result-red);       
    }
    &.seoul {
      h4 {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          background-image: url("@/assets/images/result/char_02.png");
          width: 120px;
          height: 120px;
          top: 50%;
          right: -35px;
          transform: translateY(-60%);
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
    }
  }  
} 
</style>